import ToastProvider, { useToast, ToastFunctionsType } from './useToast';

export { useToast };
export type { ToastFunctionsType };

export default ToastProvider;
